import { useUnit } from 'effector-react';
import { ChildBase, SDUI } from '@unicorn/sdui';
import { $sduiReadonly, NEW_OPENED_ID } from '../../models/detail-sdui';
import { ActionsCreate } from './components/actions/create';
import { ActionsEdit } from './components/actions/edit';
import { SduiForm } from './components/form';
import { useSduiValidation } from './useValidation';

export const DetailSdui = ({
  openedId,
  sduiData,
  ticketsSdui,
  onCreateCancel,
}: {
  openedId?: string | number | null;
  sduiData: ChildBase[];
  ticketsSdui: SDUI;
  onCreateCancel: () => void;
}) => {
  const [sduiReadonly] = useUnit([$sduiReadonly]);
  const valid = useSduiValidation({ sduiData, sduiReadonly });

  if (!openedId) return null;

  return (
    <>
      {openedId === NEW_OPENED_ID ? (
        <ActionsCreate
          valid={valid}
          sduiData={sduiData}
          onCreateCancel={onCreateCancel}
        />
      ) : (
        <ActionsEdit valid={valid} sduiData={sduiData} openedId={openedId} />
      )}

      <SduiForm ticketsSdui={ticketsSdui} />
    </>
  );
};
